export default __webpack_public_path__ + "static/media/codingMan.29147a23.jpg";